import { Box, Grid, GridProps, Link, Skeleton, Stack, SvgIcon, Typography } from '@mui/material'
import NextLink from 'next/link'

import { isHappa } from '@/hooks'

import { WPLink } from '@/types'

export type NewsCard = {
  title: string
  text: string
  date: string
  link: WPLink
}

export type NewsCardProps = GridProps & Partial<NewsCard & { skeleton: boolean }>

const NewsCard = ({ title, text, date, link, skeleton, sx, ...props }: NewsCardProps) => {
  return (
    <Grid
      sx={{
        display: 'grid',
        position: 'relative',
        flexDirection: 'column',
        padding: 2,
        gap: 4,
        alignItems: 'start',
        boxShadow: isHappa ? 'none' : `0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.08)`,
        borderRadius: (theme) => (isHappa ? theme.shape.borderRadius2 : theme.shape.borderRadius4),
        backgroundColor: isHappa ? '#E9EAF1' : 'transparent',
        ...sx
      }}
      {...props}
    >
      <Box sx={{ display: 'grid', gap: 1 }}>
        {title ? (
          <Typography variant="h6" color="text.secondaryContrastText">
            {skeleton ? (
              <Skeleton width="70%" />
            ) : link ? (
              <Link
                href={link.url}
                component={NextLink}
                scroll={false}
                color="text.secondaryContrastText"
                sx={{
                  textDecoration: 'none',
                  '&:after': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0
                  }
                }}
              >
                {title || link.title}
              </Link>
            ) : (
              title
            )}
          </Typography>
        ) : null}

        {text ? (
          <Typography variant="textRegular" color="text.secondary">
            {skeleton ? <Skeleton width="100%" height="7.2rem" /> : text}
          </Typography>
        ) : null}
      </Box>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginTop: 'auto' }}
      >
        {date ? (
          <Typography variant="textSmall" color="text.secondary">
            {skeleton ? <Skeleton width="40%" /> : date}
          </Typography>
        ) : null}

        {!skeleton ? (
          <Box sx={{ display: 'flex' }} color="text.secondary">
            <SvgIcon fontSize="small">
              <use href="#ico-arrow-next" />
            </SvgIcon>
          </Box>
        ) : null}
      </Stack>
    </Grid>
  )
}

export default NewsCard
